// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b
import i18n from '../i18n/i18n';

export const validateCheckAge = (birthdayString) => {
  const [val1, val2, val3] = birthdayString.split('/');
  if (!val1 || !val2 || !val3) {
    return i18n.t('checkBirthDayRequired');
  }

  const currentDate = new Date();

  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();
  const currentDateOfMonth = currentDate.getDate();

  let age = currentYear - val1;

  const isBeforeBirthday =
    currentMonth < val2 || (currentMonth === val2 && currentDateOfMonth <= val3);

  if (isBeforeBirthday) {
    age--;
  }

  const isOver18 = age >= 18;

  if (!isOver18) {
    return i18n.t('checkBirthDay');
  }

  return '';
};
